import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import "./style.css"

export default function DataGridDemo({ rows, columns, serverPagination, paginationMode = 'client' }) {
  const getRowId = (row) => row?._id;

  const getRowHeight = () => 90;
  
  // For server-side pagination
  const paginationModel = serverPagination ? {
    page: serverPagination.page - 1, // MUI uses 0-based index
    pageSize: serverPagination.limit,
  } : {
    page: 0,
    pageSize: 10,
  };

  const handlePaginationModelChange = (newModel) => {
    if (serverPagination && serverPagination.onPageChange) {
      serverPagination.onPageChange(newModel.page + 1, newModel.pageSize);
    }
  };

  return (
    <Box sx={{ height: rows?.length > 10 ? 700 : (rows?.length * 100) + 200, padding: "0px 10px", marginBottom: "50px", overflowX: 'auto' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationMode={paginationMode}
        rowCount={serverPagination?.total || rows?.length}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
        pageSizeOptions={[10, 15, 20, 25, 30, 40, 50, 100]}
        slots={{
          toolbar: GridToolbar,
        }}
        getRowId={getRowId}
        getRowHeight={getRowHeight}
        disableSelectionOnClick
      />
    </Box>
  );
}